import React from "react";
import { Input } from "semantic-ui-react";

interface ISearch {
  onSearch: (keyword: string) => void
}

class GuestSearch extends React.Component<ISearch, any> {
  private timeout: any;
  private readonly keyword: string;

  constructor(props) {
    super(props);
    this.state = { keyword: "" };
    this.timeout = null;
  }

  public render(): JSX.Element {
    return (
      <Input icon={"search"} onChange={this.onChange} placeholder={RESX.GeneralLabels.SearchByName} />
    );
  }

  private readonly onChange = (event: React.FormEvent<HTMLInputElement>) => {
    const keyword = event.currentTarget.value;
    if (this.timeout !== null) {
      clearTimeout(this.timeout);
    }

    this.timeout = setTimeout(() => {
      this.props.onSearch(keyword);
    }, 500);
  };
}

export default GuestSearch;
